import { useCallback, useEffect, useRef, useState } from 'react';

export default function useResourcePreview() {
  const [preview, setPreview] = useState(null);
  const previewRef = useRef(null);
  const downloads = useRef(new Set());
  const discardDownloads = useCallback(() => {
    downloads.current.forEach((url) => URL.revokeObjectURL(url));
    downloads.current.clear();
  }, []);
  const downloadFile = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    downloads.current.add(url);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => {
      if (downloads.current.delete(url)) URL.revokeObjectURL(url);
    }, 1000);
  };

  const discardPreview = useCallback(() => {
    if (previewRef.current) URL.revokeObjectURL(previewRef.current.url);
    previewRef.current = null;
  }, []);

  const closePreview = useCallback(() => {
    discardPreview();
    setPreview(null);
  }, [discardPreview]);

  const showPreview = useCallback(
    (resource, blob) => {
      discardPreview();
      const item = {
        ...resource,
        url: URL.createObjectURL(blob),
        mimeType: blob.type,
      };
      previewRef.current = item;
      setPreview(item);
    },
    [discardPreview]
  );

  useEffect(
    () => () => {
      discardPreview();
      discardDownloads();
    },
    [discardPreview, discardDownloads]
  );

  return { preview, showPreview, closePreview, discardPreview, downloadFile, discardDownloads };
}
